import React, { useState } from "react";
import "./Projects.css";
import Fade from "react-reveal/Fade";
import { FaInfoCircle, FaPlay } from "react-icons/fa";

const Projects = () => {
  // Knowledge Bubble is the main featured project

  return (
    <div className="projects-section" id="projects">
      <div className="container">
        {/* Section Header */}
        <Fade bottom>
          <div className="section-header text-center mb-5">
            <div className="badge-wrapper mb-3">
              <span className="featured-badge-new">⭐ Featured Projects</span>
            </div>
            <h1 className="section-title">
              My <span className="gradient-text">Best Work</span>
            </h1>
            <p className="section-subtitle">
              Showcasing innovative mobile and web applications
            </p>
          </div>
        </Fade>

        {/* Premium Knowledge Bubble Showcase */}
        <div className="kb-showcase mt-5">
          <Fade bottom>
            <div className="text-center mb-5">
              <img
                src="kb-logo.png"
                alt="Knowledge Bubble Logo"
                className="kb-logo-animated"
              />
              <h2 className="kb-title-gradient">
                Knowledge Bubble
              </h2>
              <p className="kb-subtitle">Revolutionary Educational Mobile Learning Platform</p>

              <div className="kb-badges-container">
                <span className="kb-status-badge live">🟢 Live on Play Store</span>
                <span className="kb-status-badge rating">⭐ 4.8+ Rating</span>
                <span className="kb-status-badge chapters">📚 10+ Chapters</span>
                <span className="kb-status-badge gamified">🎮 Gamified Learning</span>
              </div>
            </div>
          </Fade>

          <div className="row g-5 align-items-center">
            <div className="col-lg-6">
              <Fade left>
                <div className="project-image-wrapper">
                  <img
                    src="kb-preview.png"
                    alt="Knowledge Bubble App Preview"
                    className="project-main-img"
                  />
                  <div className="project-image-border-glow"></div>
                </div>
              </Fade>
            </div>

            <div className="col-lg-6">
              <Fade right>
                <div className="project-details-content">
                  <span className="project-role-badge">🏆 Featured Project - Technical Lead</span>
                  <p className="project-description-text">
                    A cutting-edge educational mobile application that transforms learning into an engaging,
                    interactive experience. Developed with <strong>React Native</strong> and <strong>TypeScript</strong>,
                    Knowledge Bubble delivers gamified educational content across multiple platforms.
                  </p>

                  <div className="key-highlights-list">
                    <div className="highlight-item">
                      <span className="highlight-icon">🎮</span>
                      <div className="highlight-text-content">
                        <h6>Gamified Experience</h6>
                        <p>Star-based progression system and achievements.</p>
                      </div>
                    </div>
                    <div className="highlight-item">
                      <span className="highlight-icon">📱</span>
                      <div className="highlight-text-content">
                        <h6>Cross-Platform</h6>
                        <p>Seamless performance on iOS and Android via React Native.</p>
                      </div>
                    </div>
                  </div>

                  <div className="tech-stack-pills">
                    {["React Native", "TypeScript", "Firebase", "Redux"].map((tech, i) => (
                      <span key={i} className="tech-pill">{tech}</span>
                    ))}
                  </div>

                  <div className="project-actions-row">
                    <a
                      href="https://play.google.com/store/apps/details?id=com.JabszGamingStudios.KnowledgeBubble&hl=en_IN"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-hire"
                    >
                      <FaPlay className="me-2" /> Play Store
                    </a>
                    {/* <button
                      className="btn btn-cv"
                    >
                      <FaInfoCircle className="me-2" /> Details
                    </button> */}
                  </div>
                </div>
              </Fade>
            </div>
          </div>
        </div>

        {/* Premium BT-Traders Showcase */}
        <div className="kb-showcase mt-5 pt-5 border-top border-secondary border-opacity-10">
          <Fade bottom>
            <div className="text-center mb-5">
              <h2 className="bt-title-gradient">
                BT-Traders Mobile Application
              </h2>
              <p className="kb-subtitle">Complete Trading Solution for Gold and Commodities</p>

              <div className="kb-badges-container">
                <span className="kb-status-badge live">🟢 Live on Play Store</span>
                <span className="kb-status-badge rating">📈 Trading Platform</span>
                <span className="kb-status-badge chapters">💳 Subscription Based</span>
                <span className="kb-status-badge gamified">🔐 Secure Auth</span>
              </div>
            </div>
          </Fade>

          <div className="row g-5 align-items-center">
            <div className="col-lg-6 order-lg-2">
              <Fade right>
                <div className="project-image-wrapper">
                  <img
                    src="BT-Traders.png"
                    alt="BT Traders App Preview"
                    className="project-main-img"
                  />
                  <div className="bt-image-border-glow"></div>
                </div>
              </Fade>
            </div>

            <div className="col-lg-6 order-lg-1">
              <Fade left>
                <div className="project-details-content">
                  <span className="bt-role-badge">💼 Freelance React Native Developer</span>
                  <p className="project-description-text">
                    Designed and developed a robust, subscription-based mobile application tailored for gold and commodity traders.
                    The app features a comprehensive ecosystem including <strong>real-time data updates</strong>,
                    <strong>video courses</strong>, and a sophisticated <strong>admin management</strong> system.
                  </p>

                  <div className="key-highlights-list">
                    <div className="highlight-item">
                      <span className="highlight-icon">💳</span>
                      <div className="highlight-text-content">
                        <h6>Subscription System</h6>
                        <p>Integrated multi-tier subscription plans for premium trading access.</p>
                      </div>
                    </div>
                    <div className="highlight-item">
                      <span className="highlight-icon">📊</span>
                      <div className="highlight-text-content">
                        <h6>Admin Dashboard</h6>
                        <p>Complete control over courses, users, and subscription management.</p>
                      </div>
                    </div>
                  </div>

                  <div className="tech-stack-pills">
                    {["React Native", "Firebase", "JWT", "REST APIs", "Node.js"].map((tech, i) => (
                      <span key={i} className="tech-pill">{tech}</span>
                    ))}
                  </div>

                  <div className="project-actions-row">
                    <a
                      href="https://play.google.com/store/apps/details?id=com.sadhak.bttraders"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-hire"
                    >
                      <FaPlay className="me-2" /> Play Store
                    </a>
                    {/* <button
                      className="btn btn-cv"
                    >
                      <FaInfoCircle className="me-2" /> Details
                    </button> */}
                  </div>
                </div>
              </Fade>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
